import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

import {
    getApprovalRequirementActionErrorKey,
    invalidateApprovalRelatedQueries,
} from "../helpers";

const useApprovalRequirementAssign = ({ softwareId, t, onSuccess } = {}) => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async ({ requirementId, userId }) => {
            const service = DataProtectionSoftwareService.getInstance();

            return await service.assignApprovalRequirement(
                softwareId,
                requirementId,
                { user_id: userId }
            );
        },
        onSuccess: () => {
            toast(t("The assignee has been updated."), {
                type: "success",
            });
            invalidateApprovalRelatedQueries(queryClient, softwareId);

            if (typeof onSuccess === "function") {
                onSuccess();
            }
        },
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t(getApprovalRequirementActionErrorKey(error)), {
                type: "error",
            });
        },
    });

    const submit = ({ requirementId, userId } = {}) => {
        if (!softwareId || !requirementId || userId == null || userId === "") {
            return;
        }

        mutation.mutate({ requirementId, userId });
    };

    return {
        submit,
        isSubmitting: mutation.isLoading,
    };
};

export default useApprovalRequirementAssign;
